// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3V8_T","addWidgetButton":"Header_addWidgetButton__19kM4","dashboardTabs":"Header_dashboardTabs__3HrKd","active":"Header_active__13zmZ"};